function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
//Material imports
import withStyles from "@mui/styles/withStyles";
import CircularProgress from "@mui/material/CircularProgress";
//Limitless imports
import CustomerButton from "../../customer-button/CustomerButton";
class ActionControlsFooter extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      disabled: false
    });
  }
  render() {
    const {
      leftButtonTitle,
      rightButtonTitle,
      leftButtonHandle,
      rightButtonHandle,
      classes,
      theme
    } = this.props;
    const actionButtonStyle = {
      flex: 1,
      borderRadius: 0,
      backgroundColor: theme.palette.contrast.light,
      color: theme.palette.contrast.main,
      boxShadow: "none",
      height: 54,
      "&:hover": {
        boxShadow: "inset 0px 0px 0px 99999px rgba(255,255,255,0.2)"
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      className: classes.actionControlsContainer
    }, /*#__PURE__*/React.createElement(CustomerButton, {
      color: "primary",
      style: {
        borderBottomLeftRadius: 12,
        ...actionButtonStyle
      },
      onClick: () => {
        this.setState({
          disabled: true
        });
        leftButtonHandle();
      },
      component: "div",
      disabled: this.state.disabled,
      id: "leftActionControlButton",
      classes: {
        label: classes.buttonLabel
      }
    }, leftButtonTitle), rightButtonHandle && /*#__PURE__*/React.createElement(CustomerButton, {
      color: "primary",
      style: {
        borderBottomRightRadius: 12,
        ...actionButtonStyle
      },
      onClick: () => {
        this.setState({
          disabled: true
        });
        rightButtonHandle();
      },
      component: "div",
      disabled: this.state.disabled,
      id: "rightActionControlButton",
      classes: {
        label: classes.buttonLabel
      }
    }, rightButtonTitle), this.state.disabled && /*#__PURE__*/React.createElement(CircularProgress, {
      size: 24,
      className: classes.actionControlsLoading
    }));
  }
}
const styles = theme => ({
  actionControlsContainer: {
    display: "flex",
    flex: "1",
    justifyContent: "space-around",
    minHeight: 54,
    position: "relative"
  },
  actionControlsLoading: {
    position: "absolute",
    marginTop: 15,
    left: "48%"
  },
  buttonLabel: {
    color: theme.palette.primary.dark
  }
});
export default withStyles(styles, {
  withTheme: true
})(ActionControlsFooter);
ActionControlsFooter.propTypes = {
  leftButtonTitle: PropTypes.string.isRequired,
  rightButtonTitle: PropTypes.string,
  leftButtonHandle: PropTypes.func.isRequired,
  rightButtonHandle: PropTypes.func,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object
};